import { axiosInstance } from '../common/api';

export const createCompOffRequest = (data) => {
  const url = `/comp-off/`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getMyCompOffRequests = (filters = {}, pagination = {}) => {
  const params = new URLSearchParams();

  if (filters.status) params.append('status', filters.status);
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  if (filters.sortBy) params.append('sortBy', filters.sortBy);
  if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);

  if (pagination.page) params.append('page', pagination.page);
  if (pagination.pageSize) params.append('pageSize', pagination.pageSize);

  const queryString = params.toString();
  const url = `/comp-off/my-comp-offs${queryString ? `?${queryString}` : ''}`;

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getAllCompOffRequests = (filters = {}, pagination = {}) => {
  const params = new URLSearchParams();

  if (filters.status) params.append('status', filters.status);
  if (filters.employeeName) params.append('employeeName', filters.employeeName);
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  if (filters.sortBy) params.append('sortBy', filters.sortBy);
  if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);
  if (filters.companyId) params.append('companyId', filters.companyId);

  if (pagination.page) params.append('page', pagination.page);
  if (pagination.pageSize) params.append('pageSize', pagination.pageSize);

  const queryString = params.toString();
  const url = `/comp-off/${queryString ? `?${queryString}` : ''}`;

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getAllCompanies = () => {
  const url = `/comp-off/companies`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getReviewers = () => {
  const url = `/comp-off/reviewers`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getCompOffById = (id) => {
  const url = `/comp-off/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const updateCompOffRequest = (id, data) => {
  const url = `/comp-off/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const updateCompOffStatus = (id, data) => {
  const url = `/comp-off/${id}/status`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

/**
 * Approve several comp-off requests at once - Admin/Manager only (rejections stay per request)
 * @param {Object} data - { ids: number[], status: 'approved' }
 * Resolves with data.data = { succeeded: number[], failed: [{ id, message }] }
 */
export const bulkUpdateCompOffStatus = (data) => {
  const url = `/comp-off/bulk-status`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const cancelCompOffRequest = (id) => {
  const url = `/comp-off/${id}/cancel`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getCompOffBalance = () => {
  const url = `/comp-off/balance`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
